import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { DocumentIcon, RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import InfoIcon from '@mui/icons-material/Info';
import InsightsIcon from '@mui/icons-material/Insights';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { AppStandardInsightsTab } from './AppStandardInsightsTab';
import { DocsTab } from './DocsTab';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  {
    id: 'app-standard-insights',
    label: 'AppStandardInsights',
    icon: InsightsIcon,
  },
  { id: 'docs', label: 'Docs', icon: DocumentIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const RepositoryEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'app-standard-insights' && <AppStandardInsightsTab />}
        {activeTab === 'docs' && <DocsTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
